import { createStaffPaymentsApi, createStaffQuotesApi } from "@lafayette/api-client";

import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import type { PaymentsRuntime } from "./runtime";

/** The runtime of the real admin app: the typed clients over `fetch` and the clock. The bearer token comes from the shared function. */
export function createAdminPaymentsRuntime(): PaymentsRuntime {
  const config = getAdminPublicConfig();
  const options = { baseUrl: config.apiUrl.toString(), getAccessToken: currentAccessToken };
  return {
    payments: createStaffPaymentsApi(options),
    quotes: createStaffQuotesApi(options),
    now: () => new Date(),
  };
}
